export default __webpack_public_path__ + "static/media/01.54026f15.jpg";